<!-- Center canvas: summary, text typed into directly, whole card is one pinnable region -->
<div class="cr-x2-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-x2-badge">2xProperty Destination Name</span>

  <div class="cr-x2-grid">
    <div class="cr-x2-item">
      <div
        class="cr-x2-dropzone"
        [appInlineMedia]="block.variables?.['X2PropRec1Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'X2PropRec1Image')"
      >
        <a *ngIf="block.variables?.['X2PropRec1Image']; else empty1" [href]="card1ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['X2PropRec1Image']" [alt]="block.variables?.['X2PropRec1ImageAlt'] || ''" />
        </a>

        <ng-template #empty1>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-x2-name"
        [appInlineEdit]="block.variables?.X2PropRec1Name ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert property name"
        (inlineEditChange)="onChange($event, 'X2PropRec1Name')"
      ></span>

      <span
        class="cr-x2-dest"
        [appInlineEdit]="block.variables?.X2PropRec1Destination ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert destination name"
        (inlineEditChange)="onChange($event, 'X2PropRec1Destination')"
      ></span>

      <a class="cr-x2-cta" [href]="card1CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.X2PropRec1CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'X2PropRec1CtaText')"
        ></span>
      </a>
    </div>

    <div class="cr-x2-item">
      <div
        class="cr-x2-dropzone"
        [appInlineMedia]="block.variables?.['X2PropRec2Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'X2PropRec2Image')"
      >
        <a *ngIf="block.variables?.['X2PropRec2Image']; else empty2" [href]="card2ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['X2PropRec2Image']" [alt]="block.variables?.['X2PropRec2ImageAlt'] || ''" />
        </a>

        <ng-template #empty2>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-x2-name"
        [appInlineEdit]="block.variables?.X2PropRec2Name ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert property name"
        (inlineEditChange)="onChange($event, 'X2PropRec2Name')"
      ></span>

      <span
        class="cr-x2-dest"
        [appInlineEdit]="block.variables?.X2PropRec2Destination ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert destination name"
        (inlineEditChange)="onChange($event, 'X2PropRec2Destination')"
      ></span>

      <a class="cr-x2-cta" [href]="card2CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.X2PropRec2CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'X2PropRec2CtaText')"
        ></span>
      </a>
    </div>
  </div>
</div>

<!-- Right panel: real edit form - two identical field groups, one per card -->
<div class="cr-x2-edit" *ngIf="!isPreview">
  <div class="cr-x2-edit-card">
    <div class="cr-x2-edit-card-title">Property 1</div>

    <div class="cr-x2-field-row">
      <span class="cr-x2-field-label">Image</span>
      <span
        class="cr-x2-toggle"
        [class.cr-x2-toggle-on]="image1AsUpload"
        role="button"
        tabindex="0"
        [title]="image1AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage1Mode()"
        (keydown.enter)="toggleImage1Mode()"
        (keydown.space)="toggleImage1Mode()"
      ></span>
    </div>
    <div class="cr-x2-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['X2PropRec1Image'] ?? ''"
        (handleOnChange)="onChange($event, 'X2PropRec1Image')"
        [placeholder]="image1Placeholder"
        variable="X2PropRec1Image"
        [isImage]="image1AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-x2-empty-overlay" *ngIf="image1AsUpload && !block.variables?.['X2PropRec1Image']">
        <div class="cr-x2-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-x2-title">Upload image</div>
        <div class="cr-x2-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-x2-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['X2PropRec1ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'X2PropRec1ImageHref')"
        [placeholder]="image1HrefPlaceholder"
        variable="X2PropRec1ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2PropRec1ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['X2PropRec1ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['X2PropRec1ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'X2PropRec1ImageAlt')"
      [placeholder]="image1AltPlaceholder"
      [maxLength]="500"
      variable="X2PropRec1ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2PropRec1Name'] ?? ''"
      (handleOnChange)="onChange($event, 'X2PropRec1Name')"
      [placeholder]="name1Placeholder"
      [maxLength]="500"
      variable="X2PropRec1Name"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2PropRec1Destination'] ?? ''"
      (handleOnChange)="onChange($event, 'X2PropRec1Destination')"
      [placeholder]="destination1Placeholder"
      [maxLength]="500"
      variable="X2PropRec1Destination"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-x2-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['X2PropRec1CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'X2PropRec1CtaLink')"
        [placeholder]="ctaLink1Placeholder"
        [maxLength]="500"
        variable="X2PropRec1CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2PropRec1CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['X2PropRec1CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2PropRec1CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'X2PropRec1CtaText')"
      [placeholder]="ctaText1Placeholder"
      [maxLength]="30"
      variable="X2PropRec1CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-x2-edit-card">
    <div class="cr-x2-edit-card-title">Property 2</div>

    <div class="cr-x2-field-row">
      <span class="cr-x2-field-label">Image</span>
      <span
        class="cr-x2-toggle"
        [class.cr-x2-toggle-on]="image2AsUpload"
        role="button"
        tabindex="0"
        [title]="image2AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage2Mode()"
        (keydown.enter)="toggleImage2Mode()"
        (keydown.space)="toggleImage2Mode()"
      ></span>
    </div>
    <div class="cr-x2-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['X2PropRec2Image'] ?? ''"
        (handleOnChange)="onChange($event, 'X2PropRec2Image')"
        [placeholder]="image2Placeholder"
        variable="X2PropRec2Image"
        [isImage]="image2AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-x2-empty-overlay" *ngIf="image2AsUpload && !block.variables?.['X2PropRec2Image']">
        <div class="cr-x2-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-x2-title">Upload image</div>
        <div class="cr-x2-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-x2-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['X2PropRec2ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'X2PropRec2ImageHref')"
        [placeholder]="image2HrefPlaceholder"
        variable="X2PropRec2ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2PropRec2ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['X2PropRec2ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['X2PropRec2ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'X2PropRec2ImageAlt')"
      [placeholder]="image2AltPlaceholder"
      [maxLength]="500"
      variable="X2PropRec2ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2PropRec2Name'] ?? ''"
      (handleOnChange)="onChange($event, 'X2PropRec2Name')"
      [placeholder]="name2Placeholder"
      [maxLength]="500"
      variable="X2PropRec2Name"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2PropRec2Destination'] ?? ''"
      (handleOnChange)="onChange($event, 'X2PropRec2Destination')"
      [placeholder]="destination2Placeholder"
      [maxLength]="500"
      variable="X2PropRec2Destination"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-x2-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['X2PropRec2CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'X2PropRec2CtaLink')"
        [placeholder]="ctaLink2Placeholder"
        [maxLength]="500"
        variable="X2PropRec2CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2PropRec2CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['X2PropRec2CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2PropRec2CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'X2PropRec2CtaText')"
      [placeholder]="ctaText2Placeholder"
      [maxLength]="30"
      variable="X2PropRec2CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
